<div class="grid-max-width grid-col-12" *ngIf="profile$ | async">
  <div class="xl-col-2-7 md-col-1-9 col-1-12 ps-large-y font-body-1">
    <h2 class="ms-large-b">{{ 'CORPORATE.corporatePortal.addUser.header' | finLocalization }}</h2>
    <h4 class="ms-large-b">{{ 'CORPORATE.corporatePortal.personalDetails' | finLocalization }}</h4>
    <fin-personal-details-form [formGroup]="personalDetailsForm"></fin-personal-details-form>

    <ng-container *ngIf="false">
      <!-- To be enabled after booking flow supports corporate passport details -->
      <h4 class="ms-large-b">{{ 'CORPORATE.corporatePortal.passportDetails' | finLocalization }}</h4>
      <fin-passport-details-form [formGroup]="passportDetailsForm"></fin-passport-details-form>
    </ng-container>

    <h4 class="ms-large-b">{{ 'CORPORATE.corporatePortal.userDetails' | finLocalization }}</h4>
    <div class="flex flex--column border rounded-large ms-large-b credentials">
      <div class="flex border-bottom ps-small">
        <div class="credentials-label">
          {{ 'CORPORATE.corporatePortal.addUser.fields.username.label' | finLocalization }}
        </div>
        <div class="bold-type">
          <span>
            {{ 'CORPORATE.corporatePortal.addUser.fields.username.description' | finLocalization }}
          </span>
        </div>
      </div>
      <div class="flex ps-small">
        <div class="credentials-label">
          {{ 'CORPORATE.corporatePortal.addUser.fields.password.label' | finLocalization }}
        </div>
        <div class="bold-type">
          <span>
            {{ 'CORPORATE.corporatePortal.addUser.fields.password.description' | finLocalization }}
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="isTravelBooker$ | async" class="flex flex--column border rounded-large ms-large-b credentials">
      <div class="flex ps-small">
        <div class="credentials-label">
          {{ 'CORPORATE.corporatePortal.addUser.fields.role.label' | finLocalization }}
        </div>
        <div class="bold-type">
          <span>
            {{ 'CORPORATE.corporatePortal.roles.T' | finLocalization }}
          </span>
        </div>
      </div>
    </div>
    <fin-user-details-form *ngIf="isAdmin$ | async" [formGroup]="userDetailsForm"></fin-user-details-form>

    <fcom-notification *ngIf="errorNotification$ | async" [theme]="NotificationTheme.ALERT" class="ms-large-b">
      {{ 'CORPORATE.corporatePortal.addUser.createError' | finLocalization }}
    </fcom-notification>

    <div class="flex flex--end">
      <fcom-button
        data-testid="corporate-cancel-add-user"
        [text]="'actions.cancel' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [disabled]="posting"
        (clickBtn)="navigateBack()"
      ></fcom-button>
      <fcom-button
        data-testid="corporate-add-user-submit"
        class="ms-large-l"
        [text]="'CORPORATE.corporatePortal.addUser.addUserBtn' | finLocalization"
        [loading]="posting"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        (clickBtn)="submit()"
      ></fcom-button>
    </div>
  </div>
</div>
